<template>
  <div class="rounded-sm bg-red-50 p-4" v-if="errors.length > 0">
    <div class="flex">
      <div class="text-sm text-red-700">
        <ul role="list" class="list-disc space-y-1 pl-5">
          <li class="text-left" v-for="error in errors" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { usePage } from "@inertiajs/vue3";

const props = defineProps({
  errors: Object,
});

const errors = computed(() => {
  if (props.errors) {
    return Object.values(props.errors);
  }

  return Object.values(usePage().props.errors);
});

onMounted(() => {
  // Clear logs when component with this error component is mounted
  // Errors will only be shown on submission of the form
  usePage().props.errors = {};
});
</script>
